export default __webpack_public_path__ + "static/media/accountwhite.7ac6383f.svg";